import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=2570a9b7&scoped=true&"
import script from "./SearchBox.vue?vue&type=script&lang=js&"
export * from "./SearchBox.vue?vue&type=script&lang=js&"
import style0 from "./SearchBox.vue?vue&type=style&index=0&id=2570a9b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2570a9b7",
  null
  
)

export default component.exports